import {ID, Response} from '../../../../../../_metronic/helpers'
export type Automation = {
  _id?: ID
  description?: string,
  expression?: string,
  timezone?: string,
  link? : string,
  logs? : string[]
}

export type UsersQueryResponse = Response<Array<Automation>>

export const initialUser: Automation = {
  description : '',
  expression : '',
  timezone: '',
  link : '',
  logs : []
}
